/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Login_Aside_PromptInputs */

const en_auth_login_aside_prompt = /** @type {(inputs: Auth_Login_Aside_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New here?`)
};

const pl_auth_login_aside_prompt = /** @type {(inputs: Auth_Login_Aside_PromptInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pierwszy raz tutaj?`)
};

/**
* | output |
* | --- |
* | "New here?" |
*
* @param {Auth_Login_Aside_PromptInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const auth_login_aside_prompt = /** @type {((inputs?: Auth_Login_Aside_PromptInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Login_Aside_PromptInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_auth_login_aside_prompt(inputs)
	return en_auth_login_aside_prompt(inputs)
});